module.exports = __webpack_public_path__ + "img/003-austria.5a31204b.svg";